module.exports = "img/flags/SJ.f24fdc2.png";